import React from "react";
import { Container, Row, Col, Card, CardImg } from "reactstrap";
import cn from "classnames";

import * as style from "./description.module.scss";

const Description = () => {
  return (
    <>
      <section id="description">
        <Row className={cn(style.description, "p-5")}>
          <h2 className="mb-4">About me</h2>
          <p>
            JavaScript lover, React fan, entrepreneur and product manager. I'm a
            curious person who is always learning something new, often looking
            for how to create products that have a positive impact on people's
            lives. Currently doing my best to become a successful PM. I love
            working closely with cross-functional teams that include designers,
            engineers, marketing and customer service managers. This
            collaborative environment fosters teamwork and communication,
            allowing for knowledge sharing and learning from others. I identify
            myself with the culture of learning and growth promotes a positive
            mindset and fosters personal and professional development. I have
            chosen to accept the risk and responsibility of making bold and
            impactful decisions to positively impact people's lives.
          </p>
        </Row>
      </section>
    </>
  );
};

export default Description;
